//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Base from './rb-base.vue'
export default {
  name: 'rb-textfield',
  extends: Base,
  props: {
    minlength: Number,
    maxlength: Number,
    pattern: String,
    iconclass: String,
    isEmail: { type: Boolean, default: false },
    placeholder: { type: String, default: ' ' },
    textfieldAriaLabelError: { type: String, default: '' },
    textfieldAriaLabelDefault: { type: String, default: '' },
  },
  data: function () {
    return {
      icon: this.iconclass || undefined,
    }
  },
  computed: {
    isIcon() {
      return this.iconclass ? this.iconclass : false
    },

    inputAriaLabel() {
      return this.textfieldAriaLabelError && this.isInValidRow
        ? this.textfieldAriaLabelError
        : this.textfieldAriaLabelDefault
    },
  },
  watch: {
    initialvalue(value) {
      this.value = value
    },
    value(value) {
      if (this.isEmail) {
        this.value = value?.toLowerCase()
      }
    },
  },
  methods: {
    togglePassword: function () {
      let el = this.$refs.field
      if (el.type === 'password') {
        el.type = 'text'
        this.icon = 'common__icon--visibility-off'
      } else {
        el.type = 'password'
        this.icon = 'common__icon--visibility-on'
      }
      return el
    },
    focus() {
      setTimeout(() => {
        this.onFocusIn()
        this.$refs.field.focus()
      })
    },
    onIconClick() {
      this.$emit('onIconClick')
    },
  },
}
